import { PageWithLayout } from './_app';
import Main, { makeTitle } from '@/components/layouts/Main';
import Head from 'next/head';
import BoxFull from '@/components/box/BoxFull';
import Twitter from '@/components/icons/Twitter';

type AboutProps = {};

const About: PageWithLayout<AboutProps> = ({}) => {
  const members = [
    {
      name: 'Marcello Salvati',
      title: '(Founder & CEO)',
      twitter: 'byt3bl33d3r',
    },
    {
      name: 'Sol Ozzan',
      title: '(Co-Founder & President)',
      twitter: 'encodedwitch',
    },
  ];

  return (
    <>
      <Head>
        <title>{makeTitle('Team')}</title>
      </Head>
      <BoxFull type={`happy`} title={`Porchetta Team`} mainTitle={`Team`}>
        <ul className="mt-5">
          {members.map((member) => (
            <li className="text-porchetta-white mb-10">
              <p>
                <strong>{member.name}</strong> {member.title}
              </p>
              <p className="mt-1">
                <a
                  className="flex items-center text-porchetta-green"
                  href={'https://twitter.com/' + member.twitter}>
                  <span className="w-4 h-4 inline-flex mr-1">
                    <Twitter />
                  </span>
                  @{member.twitter}
                </a>
              </p>
            </li>
          ))}
        </ul>
      </BoxFull>
    </>
  );
};

About.Layout = Main;

export default About;
